module.exports = "/wp-content/themes/onnit/script/cart/dist/abiOverride-c9ddbd8b.png";